module.exports = __webpack_public_path__ + "6ff7d7f4422fe17d8397d021b3b75ede.svg";